<template>
    <div  v-if="enabled" :id="id" class="overlay">
        <div :class="enabled ? 'overlay-content overlay-active': 'overlay-content overlay-not-active'">
            <!-- <i :class="iconClass"></i> -->
            <span class="h4 overlay-title">{{ loaderTitle }}</span>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['enabled', 'title'],

    data () {
      return {
        id: 'app-overlay',
        iconClass: 'icon-refresh icon-spin',
        loaderTitle: this.$options.filters.translate("loadingTitle"),
        loaderDesc: ''
      }
    },

    created() {
        if (this.title)
            this.loaderTitle = this.$options.filters.translate(this.title);
    }
  }
</script>

<style>
.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: hsla(0,0%,100%,.75);
    z-index: 10;
    cursor: default;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    text-align: center;
    -ms-user-select: none;
}
.overlay-not-active {
    display: none;
}
.overlay-active {
    display: block;
}
.overlay-content {
    position: relative;
    top: 40%;
}
.overlay-title {
    color: #010936;
}
.icon-spin {
    animation: icon-spin 2s infinite linear;
    display: block!important;
}
</style>